import { HttpClient } from '../../httpClient'
import type { OpalApi } from '../../schema'

type CreateCoolaboratorV3 = OpalApi<'CreateBoardCollaboratorV3', 201>

export const createBoardCollaborator: CreateCoolaboratorV3 = ({
  requestBody,
}: Parameters<CreateCoolaboratorV3>[0] = {}) => {
  const url = new URL(`/board_collaborators/v3`, window.location.origin)

  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
